// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-gradient-start: #000000;
  --bg-gradient-end: #7f7f7f;
}

html {
  background-color: var(--bg-gradient-end);
  transition: background-color 500ms ease-in-out;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Open Sans";
  color: #fff;
}

p {
  margin: 0;
}

.content-background-container {
  position: fixed;
  top: 0;
}

.content-background-gradient {
  background: linear-gradient(
    to bottom,
    var(--bg-gradient-start) 0%,
    var(--bg-gradient-end) 90%
  );
  height: 100vh;
  width: 100vw;
  position: absolute;
}

.hero-image {
  mask-image: linear-gradient(to bottom, #ffffff, #ffffff30, #00000000);
  -webkit-mask-image: linear-gradient(to bottom, #ffffff, #ffffff30, #00000000);
  filter: saturate(0.8);
  width: 100vw;
  height: 60vh;
  object-fit: cover;
  user-select: none;
  -webkit-user-select: none;
  position: absolute;
}

.home-bottom-bar {
  position: fixed;
  bottom: 0;
  width: calc(100vw - 3rem);
  height: 4rem;
  background-color: var(--bg-gradient-end);
  transition: background-color 500ms ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px #00000008 solid;
  padding-inline: 1.5rem;
}

.home-bottom-bar > * {
  height: fit-content;
}

.home-bottom-bar > * > svg {
  height: 2rem;
  width: 2rem;
}

.home-bottom-bar > button {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}

.inner-content {
  position: relative;
  max-width: 640px;
  margin-inline: auto;
  padding-inline: 1rem;
  margin-bottom: 5rem;
}

.hero-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.hero-container p {
  text-shadow: #00000050 1px 1px 10px;
}

.hero-row1-city {
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.8;
}

.hero-temp {
  font-size: clamp(5rem, 25vw, 8rem);
  font-weight: 300;
  margin: -1.25rem;
}

.hero-condition {
  font-size: 1.25rem;
  margin-block: 0.25rem;
  font-weight: 600;
}

.hero-last-row {
  font-size: 1.25rem;
  font-weight: 500;
}

.days-container {
  display: flex;
  gap: 0.75rem;
  width: fit-content;
  width: calc(100vw - 2rem);
  max-width: 640px;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.days-container::-webkit-scrollbar {
  display: none;
}

.days-card {
  flex: 1 1 0;
  width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  backdrop-filter: blur(15px) saturate(120%) brightness(90%);
  -webkit-backdrop-filter: blur(5px) saturate(120%) brightness(90%);
  padding: 1rem;
  border-radius: 15px;
  min-width: 7rem;
  border: rgba(255, 255, 255, 0.15) 1px solid;
}

.days-card-day {
  font-weight: 700;
}

.days-avg-temp {
  font-size: 1.5em;
  font-weight: 700;
  margin-top: 0;
}

.days-card svg {
  height: 2em;
  width: 2em;
}

.days-temp-range {
  display: flex;
  font-size: 0.85em;
  gap: 0.125em;
}

.days-temp-range > p {
  font-weight: 600;
}

@supports (-webkit-backdrop-filter: blur(5px)) {
  .days-temp-range > p,
  .grid-card-title,
  .source-container {
    -webkit-mask: linear-gradient(#000 0 0) text;
    mask: linear-gradient(#000 0 0) text;
    -webkit-backdrop-filter: contrast(180%) brightness(120%);
    backdrop-filter: contrast(180%) brightness(120%);
    color: rgba(255, 255, 255, 0.65);
  }
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-block: 1rem;
}

.grid-item-card {
  aspect-ratio: 1/1;
  backdrop-filter: blur(15px) saturate(120%) brightness(90%);
  -webkit-backdrop-filter: blur(5px) saturate(120%) brightness(90%);
  border: rgba(255, 255, 255, 0.15) 1px solid;
  padding: 1rem;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
}

.grid-card-title {
  font-weight: 700;
  font-size: 0.85rem;
  margin-top: -0.25rem;
}

.grid-card-data {
  font-size: 2rem;
  margin-block: auto;
  text-shadow: #0000002b 1px 1px 10px;
}

.source-container {
  font-size: 1.125rem;
}

.source-container > a {
  color: #fff;
  text-decoration: none;
  font-weight: 700;
}

.overlay-container {
  background: #1b1b1b00;
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 750ms cubic-bezier(0.075, 0.82, 0.165, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.overlay-close-button {
  padding: 0.5rem;
  border-radius: 1000px;
  background-color: #ffffff30;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 500ms cubic-bezier(0.075, 0.82, 0.165, 1);
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
}

.overlay-close-button:hover {
  background-color: #ffffff60;
}

.searchbar-config,
.searchbar-search {
  width: calc(100% - 4.5rem);
  max-width: calc(640px - 2rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.search-input-config,
.search-input-search {
  flex-grow: 1;
  padding: 0 1rem;
  height: 3.25rem;
  font-size: 1.125rem;
  border-radius: 10px;
  outline: none;
  border: 1px #ffffff30 solid;
  background-color: #2a2a2a;
  color: #fff;
}

.search-input-config:focus,
.search-input-search:focus {
  border-color: #0064ff;
}

.search-button-config,
.search-button-search {
  padding-inline: 2rem;
  height: 3.25rem;
  font-size: 1.125rem;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  background-color: #0064ff;
  color: #fff;
  border: #ffffff00 1px solid;
  cursor: pointer;
  transition: all 500ms cubic-bezier(0.075, 0.82, 0.165, 1);
}

.search-button-config:hover,
.search-button-search:hover {
  border: #4791ff 1px solid;
}

.loading-search,
.loading-config {
  height: 0;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  background-color: #4c4c4c;
  color: #fff !important;
  font-size: 1rem !important;
  border-radius: 100px;
  transition: all 150ms cubic-bezier(0.075, 0.82, 0.165, 1);
}

.info-search {
  font-size: 0.85rem;
  color: #4c4c4c;
  text-align: justify;
  width: calc(100% - 4.5rem);
  max-width: calc(640px - 2rem);
}

.stop-scroll {
  height: 100%;
  overflow-x: hidden;
  position: fixed;
}

.units-selector-settings {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: #141414;
  border: #ffffff30 1px solid;
  padding: 1rem 2rem;
  margin-inline: 1rem;
  border-radius: 15px;
  width: calc(100% - 6.5rem);
  max-width: calc(640px - 4rem);
}

.units-selector-settings > p {
  font-weight: 700;
  font-size: 1.25rem;
}

.selector-units-settings {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  height: 3.75rem;
  padding-inline: 1.5rem;
  border-radius: 1000px;
  border: #0064ff 2px solid;
  position: relative;
  cursor: pointer;
  margin-inline: auto;
}

.selector-units-settings > p {
  z-index: 10;
  width: 5rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 600;
}

.side-units-settings {
  position: absolute;
  background-color: #0064ff;
  height: 3.25rem;
  border-radius: 1000px;
}

.container-about {
  max-width: calc(640px - 4rem);
  margin-inline: 1rem;
  display: flex;
  flex-direction: column;
  background-color: #141414;
  border: #ffffff30 1px solid;
  padding: 1rem 2rem;
  border-radius: 15px;
}

.container-about > h1 {
  margin-block: 0;
  font-size: 1.25rem;
  cursor: pointer;
  text-decoration: underline;
}

.text-wrapper-about {
  display: grid;
  grid-template-rows: 0fr;
  width: 0;
  transition: all 150ms cubic-bezier(0.075, 0.82, 0.165, 1);
}

.about-open .text-wrapper-about {
  grid-template-rows: 1fr;
  width: 100%;
  margin-top: 1rem;
}

.container-about > .text-wrapper-about > p {
  color: #7f7f7f;
  text-align: justify;
  overflow: hidden;
}

.container-about > .text-wrapper-about > p > a {
  color: #0064ff;
  text-decoration: none;
  font-weight: 700;
  cursor: pointer;
}

.container-config {
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: #050505;
  z-index: 100;
  overflow-y: scroll;
  transition: opacity 500ms cubic-bezier(0.075, 0.82, 0.165, 1);
}

.inner-content-config {
  max-width: calc(640px - 2rem);
  width: calc(100% - 2rem);
  height: 100vh;
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.inner-content-config > p {
  color: #4c4c4c;
  font-size: 0.85rem;
  text-align: justify;
}

.current-button-config {
  background-color: #0064ff;
  padding-inline: 2rem 2.5rem;
  height: 3rem;
  width: 100%;
  border-radius: 10px;
  border: transparent 1px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #fff;
  font-weight: 600;
  font-size: 1.125rem;
  cursor: pointer;
}

.current-button-config:hover {
  border-color: #4791ff;
}


.searchbar-config {
  width: 100%;
}

@media only screen and (min-width: 500px) {
  .grid-container {
    grid-template-columns: repeat(3, 1fr);
  }
  .days-card {
    font-size: 1.125rem;
    aspect-ratio: 1/1;
  }
  .searchbar-config,
  .searchbar-search {
    flex-direction: row;
  }
  .units-selector-settings {
    flex-direction: row;
    align-items: center;
    gap: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;AACR;;AAEA;EACE;;;;GAIC;EACD,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qEAAqE;EACrE,6EAA6E;EAC7E,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;EACxC,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0DAA0D;EAC1D,iEAAiE;EACjE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,4CAA4C;IAC5C,oCAAoC;IACpC,wDAAwD;IACxD,gDAAgD;IAChD,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0DAA0D;EAC1D,iEAAiE;EACjE,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yDAAyD;EACzD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,yDAAyD;AAC3D;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap\");\n\n:root {\n  --bg-gradient-start: #000000;\n  --bg-gradient-end: #7f7f7f;\n}\n\nhtml {\n  background-color: var(--bg-gradient-end);\n  transition: background-color 500ms ease-in-out;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: \"Open Sans\";\n  color: #fff;\n}\n\np {\n  margin: 0;\n}\n\n.content-background-container {\n  position: fixed;\n  top: 0;\n}\n\n.content-background-gradient {\n  background: linear-gradient(\n    to bottom,\n    var(--bg-gradient-start) 0%,\n    var(--bg-gradient-end) 90%\n  );\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n}\n\n.hero-image {\n  mask-image: linear-gradient(to bottom, #ffffff, #ffffff30, #00000000);\n  -webkit-mask-image: linear-gradient(to bottom, #ffffff, #ffffff30, #00000000);\n  filter: saturate(0.8);\n  width: 100vw;\n  height: 60vh;\n  object-fit: cover;\n  user-select: none;\n  -webkit-user-select: none;\n  position: absolute;\n}\n\n.home-bottom-bar {\n  position: fixed;\n  bottom: 0;\n  width: calc(100vw - 3rem);\n  height: 4rem;\n  background-color: var(--bg-gradient-end);\n  transition: background-color 500ms ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px #00000008 solid;\n  padding-inline: 1.5rem;\n}\n\n.home-bottom-bar > * {\n  height: fit-content;\n}\n\n.home-bottom-bar > * > svg {\n  height: 2rem;\n  width: 2rem;\n}\n\n.home-bottom-bar > button {\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.inner-content {\n  position: relative;\n  max-width: 640px;\n  margin-inline: auto;\n  padding-inline: 1rem;\n  margin-bottom: 5rem;\n}\n\n.hero-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 50vh;\n}\n\n.hero-container p {\n  text-shadow: #00000050 1px 1px 10px;\n}\n\n.hero-row1-city {\n  font-weight: 600;\n  text-transform: uppercase;\n  opacity: 0.8;\n}\n\n.hero-temp {\n  font-size: clamp(5rem, 25vw, 8rem);\n  font-weight: 300;\n  margin: -1.25rem;\n}\n\n.hero-condition {\n  font-size: 1.25rem;\n  margin-block: 0.25rem;\n  font-weight: 600;\n}\n\n.hero-last-row {\n  font-size: 1.25rem;\n  font-weight: 500;\n}\n\n.days-container {\n  display: flex;\n  gap: 0.75rem;\n  width: fit-content;\n  width: calc(100vw - 2rem);\n  max-width: 640px;\n  overflow-x: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.days-container::-webkit-scrollbar {\n  display: none;\n}\n\n.days-card {\n  flex: 1 1 0;\n  width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n  backdrop-filter: blur(15px) saturate(120%) brightness(90%);\n  -webkit-backdrop-filter: blur(5px) saturate(120%) brightness(90%);\n  padding: 1rem;\n  border-radius: 15px;\n  min-width: 7rem;\n  border: rgba(255, 255, 255, 0.15) 1px solid;\n}\n\n.days-card-day {\n  font-weight: 700;\n}\n\n.days-avg-temp {\n  font-size: 1.5em;\n  font-weight: 700;\n  margin-top: 0;\n}\n\n.days-card svg {\n  height: 2em;\n  width: 2em;\n}\n\n.days-temp-range {\n  display: flex;\n  font-size: 0.85em;\n  gap: 0.125em;\n}\n\n.days-temp-range > p {\n  font-weight: 600;\n}\n\n@supports (-webkit-backdrop-filter: blur(5px)) {\n  .days-temp-range > p,\n  .grid-card-title,\n  .source-container {\n    -webkit-mask: linear-gradient(#000 0 0) text;\n    mask: linear-gradient(#000 0 0) text;\n    -webkit-backdrop-filter: contrast(180%) brightness(120%);\n    backdrop-filter: contrast(180%) brightness(120%);\n    color: rgba(255, 255, 255, 0.65);\n  }\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n  margin-block: 1rem;\n}\n\n.grid-item-card {\n  aspect-ratio: 1/1;\n  backdrop-filter: blur(15px) saturate(120%) brightness(90%);\n  -webkit-backdrop-filter: blur(5px) saturate(120%) brightness(90%);\n  border: rgba(255, 255, 255, 0.15) 1px solid;\n  padding: 1rem;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n.grid-card-title {\n  font-weight: 700;\n  font-size: 0.85rem;\n  margin-top: -0.25rem;\n}\n\n.grid-card-data {\n  font-size: 2rem;\n  margin-block: auto;\n  text-shadow: #0000002b 1px 1px 10px;\n}\n\n.source-container {\n  font-size: 1.125rem;\n}\n\n.source-container > a {\n  color: #fff;\n  text-decoration: none;\n  font-weight: 700;\n}\n\n.overlay-container {\n  background: #1b1b1b00;\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: all 750ms cubic-bezier(0.075, 0.82, 0.165, 1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.overlay-close-button {\n  padding: 0.5rem;\n  border-radius: 1000px;\n  background-color: #ffffff30;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 500ms cubic-bezier(0.075, 0.82, 0.165, 1);\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  cursor: pointer;\n}\n\n.overlay-close-button:hover {\n  background-color: #ffffff60;\n}\n\n.searchbar-config,\n.searchbar-search {\n  width: calc(100% - 4.5rem);\n  max-width: calc(640px - 2rem);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.search-input-config,\n.search-input-search {\n  flex-grow: 1;\n  padding: 0 1rem;\n  height: 3.25rem;\n  font-size: 1.125rem;\n  border-radius: 10px;\n  outline: none;\n  border: 1px #ffffff30 solid;\n  background-color: #2a2a2a;\n  color: #fff;\n}\n\n.search-input-config:focus,\n.search-input-search:focus {\n  border-color: #0064ff;\n}\n\n.search-button-config,\n.search-button-search {\n  padding-inline: 2rem;\n  height: 3.25rem;\n  font-size: 1.125rem;\n  font-weight: 600;\n  border-radius: 10px;\n  border: none;\n  background-color: #0064ff;\n  color: #fff;\n  border: #ffffff00 1px solid;\n  cursor: pointer;\n  transition: all 500ms cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.search-button-config:hover,\n.search-button-search:hover {\n  border: #4791ff 1px solid;\n}\n\n.loading-search,\n.loading-config {\n  height: 0;\n  overflow: hidden;\n  opacity: 0;\n  position: absolute;\n  background-color: #4c4c4c;\n  color: #fff !important;\n  font-size: 1rem !important;\n  border-radius: 100px;\n  transition: all 150ms cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.info-search {\n  font-size: 0.85rem;\n  color: #4c4c4c;\n  text-align: justify;\n  width: calc(100% - 4.5rem);\n  max-width: calc(640px - 2rem);\n}\n\n.stop-scroll {\n  height: 100%;\n  overflow-x: hidden;\n  position: fixed;\n}\n\n.units-selector-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  background-color: #141414;\n  border: #ffffff30 1px solid;\n  padding: 1rem 2rem;\n  margin-inline: 1rem;\n  border-radius: 15px;\n  width: calc(100% - 6.5rem);\n  max-width: calc(640px - 4rem);\n}\n\n.units-selector-settings > p {\n  font-weight: 700;\n  font-size: 1.25rem;\n}\n\n.selector-units-settings {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n  height: 3.75rem;\n  padding-inline: 1.5rem;\n  border-radius: 1000px;\n  border: #0064ff 2px solid;\n  position: relative;\n  cursor: pointer;\n  margin-inline: auto;\n}\n\n.selector-units-settings > p {\n  z-index: 10;\n  width: 5rem;\n  text-align: center;\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.side-units-settings {\n  position: absolute;\n  background-color: #0064ff;\n  height: 3.25rem;\n  border-radius: 1000px;\n}\n\n.container-about {\n  max-width: calc(640px - 4rem);\n  margin-inline: 1rem;\n  display: flex;\n  flex-direction: column;\n  background-color: #141414;\n  border: #ffffff30 1px solid;\n  padding: 1rem 2rem;\n  border-radius: 15px;\n}\n\n.container-about > h1 {\n  margin-block: 0;\n  font-size: 1.25rem;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.text-wrapper-about {\n  display: grid;\n  grid-template-rows: 0fr;\n  width: 0;\n  transition: all 150ms cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.about-open .text-wrapper-about {\n  grid-template-rows: 1fr;\n  width: 100%;\n  margin-top: 1rem;\n}\n\n.container-about > .text-wrapper-about > p {\n  color: #7f7f7f;\n  text-align: justify;\n  overflow: hidden;\n}\n\n.container-about > .text-wrapper-about > p > a {\n  color: #0064ff;\n  text-decoration: none;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.container-config {\n  position: absolute;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  background-color: #050505;\n  z-index: 100;\n  overflow-y: scroll;\n  transition: opacity 500ms cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.inner-content-config {\n  max-width: calc(640px - 2rem);\n  width: calc(100% - 2rem);\n  height: 100vh;\n  margin-inline: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.inner-content-config > p {\n  color: #4c4c4c;\n  font-size: 0.85rem;\n  text-align: justify;\n}\n\n.current-button-config {\n  background-color: #0064ff;\n  padding-inline: 2rem 2.5rem;\n  height: 3rem;\n  width: 100%;\n  border-radius: 10px;\n  border: transparent 1px solid;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: #fff;\n  font-weight: 600;\n  font-size: 1.125rem;\n  cursor: pointer;\n}\n\n.current-button-config:hover {\n  border-color: #4791ff;\n}\n\n\n.searchbar-config {\n  width: 100%;\n}\n\n@media only screen and (min-width: 500px) {\n  .grid-container {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .days-card {\n    font-size: 1.125rem;\n    aspect-ratio: 1/1;\n  }\n  .searchbar-config,\n  .searchbar-search {\n    flex-direction: row;\n  }\n  .units-selector-settings {\n    flex-direction: row;\n    align-items: center;\n    gap: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
